// extracted by mini-css-extract-plugin
export var preview = "style-module--preview--dcb0a";
export var swiperButtonNext = "style-module--swiper-button-next--69bba";
export var swiperButtonPrev = "style-module--swiper-button-prev--5e319";
export var swiperButtons = "style-module--swiper-buttons--2b059";